import React from "react";
import styles from "../assets/css/Logo.module.css";

export default function Logo({ ...rest }) {
  return (
    <>
      <svg
        className={styles.logo}
        viewBox="0 0 232 238"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M213.93 94.4301L46.07 5.0001C34.87 -0.969897 23.27 -1.6199 14.22 3.1901C5.18 8.0101 0 17.6201 0 29.5501V208.42C0 220.34 5.18 229.95 14.22 234.77C23.27 239.58 34.87 238.92 46.07 232.96L213.94 143.53C225.13 137.56 231.56 128.61 231.56 118.98C231.55 109.35 225.12 100.4 213.93 94.4301ZM204.32 133.59L105.85 186.06V136.64H58.36V147.27L21.36 127.56L58.36 107.86V118.49H135.96V128.94L172.94 109.23L135.96 89.5301V100.17H105.85V51.9101L204.32 104.38C219.39 112.41 219.39 125.55 204.32 133.59Z"
          {...rest}
        />
      </svg>
    </>
  );
}
